import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Vehicle} from "./add-vehicles/add-vehicles.component";
import {Driverdata} from "./add-info/add-info.component";
import { environment } from 'src/environments/environment';
import { isDevMode } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {
  private env = isDevMode() ? environment.testMode : environment.productionMode;

  constructor(private firestore: AngularFirestore) {
  }

  addVehicle(vehicle: Vehicle): Promise<any> {
    return this.firestore.collection(this.env.vehicles).add(vehicle);
  }

  getVehicles(): Observable<any> {
    return this.firestore.collection(this.env.vehicles).valueChanges({idField: 'id'});
  }

  updateVehicle(id: string, data: Vehicle): Promise<void> {
    return this.firestore.collection(this.env.vehicles).doc(id).update(data);
  }


  deleteVehicle(id: string): Promise<void> {
    return this.firestore.collection(this.env.vehicles).doc(id).delete();
  }

  addDriverData(driverData: Driverdata) {
    return this.firestore.collection(this.env.drivers).add(driverData);
  }
  getDriver() {
    return this.firestore.collection(this.env.drivers).valueChanges({idField:'id'})
  }

  updateDriverData(driverData: Driverdata, id: string) {
    return this.firestore.collection(this.env.drivers).doc(id).update(driverData);
  }

  deleteDriverData(id: string): Promise<void> {
    return this.firestore.collection(this.env.drivers).doc(id).delete();
  }

  carLogDelete(id:string):Promise<void> {
    return this.firestore.collection(this.env.trips).doc(id).delete()
  }


  addDCarFuelsData(carData: any) {
    return this.firestore.collection(this.env.petrolFilling).add(carData);
  }
  updateDCarFuelsData(carId: string, carData: any) {
    return this.firestore.collection(this.env.petrolFilling).doc(carId).update(carData);
  }
  getCarFuelsData() {
    return this.firestore.collection(this.env.petrolFilling).valueChanges({idField:'id'})
  }
  updateFuelsData(id: string, data: Vehicle){
    return this.firestore.collection(this.env.petrolFilling).doc(id).update(data);
  }

  deleteCarFuelsData(id:any) {
    return this.firestore.collection(this.env.petrolFilling).doc(id).delete()
  }

  addServicingData(carData: any) {
    return this.firestore.collection(this.env.vehicleServicing).add(carData);
  }
  getServicingData() {
    return this.firestore.collection(this.env.vehicleServicing).valueChanges({idField:'id'})
  }
  updateServicingData(id: string, data: Vehicle){
    return this.firestore.collection(this.env.vehicleServicing).doc(id).update(data);
  }


  deleteServicingData(id:any) {
    return this.firestore.collection(this.env.vehicleServicing).doc(id).delete()
  }
  getALTrips(){
    return this.firestore.collection(this.env.trips).valueChanges({idField:'id'})
  }
}
